export const blockIconsUiactionsHomeNew = (
	<span className='material-symbols-outlined'>home</span>
);
